import React from 'react'
import { routerPropTypes } from 'Types'
import PropTypes from 'prop-types'
import { Link } from 'Blocks'
import { Helmet } from 'react-helmet-async'
import { getPaginationRels, UrlBuilder } from 'Utils'

// TODO: Not up to ANT Standards: needs refactoring
const ExtendedPagination = ({ className = '', pagination, location }) => {
  const queryString = location.search
  const urlBuilder = new UrlBuilder(queryString)
  const urlBuilder1 = new UrlBuilder(queryString)
  const urlBuilder2 = new UrlBuilder(queryString)
  const urlBuilder3 = new UrlBuilder(queryString)
  const urlBuilder4 = new UrlBuilder(queryString)
  const urlBuilder5 = new UrlBuilder(queryString)
  const urlBuilder6 = new UrlBuilder(queryString)
  const currentPage = urlBuilder.getPage()

  const PaginationProps = {
    location,
    totalPages: pagination.pages
  }

  const paginationRelLinks = getPaginationRels(PaginationProps)
  if (pagination.pages > 1) {
    return (
      <div className={`pagination ${className}`}>
        <Helmet>{paginationRelLinks}</Helmet>
        <div className="paginate-text">
          {pagination.previous && (
            <Link
              className="prev-button"
              to={urlBuilder.setPage(pagination.previous).getQueryString()}
            >
              {'Previous'}
            </Link>
          )}
          {pagination.previous >= 3 && (
            <Link
              className="prev-button"
              to={urlBuilder1.setPage(1).getQueryString()}
            >
              {1}
            </Link>
          )}
          {pagination.previous >= 3 && <span> ... </span>}
          {pagination.previous && (
            <Link
              className="prev-button"
              to={urlBuilder2.setPage(pagination.previous).getQueryString()}
            >
              {pagination.previous}
            </Link>
          )}
          <span className="currentPage">{currentPage}</span>
          {currentPage < pagination.pages && (
            <Link
              className="next-button"
              to={urlBuilder3.setPage(pagination.next).getQueryString()}
            >
              {pagination.next}
            </Link>
          )}
          {currentPage + 2 < pagination.pages && pagination.next < 3 && (
            <Link
              className="next-button"
              to={urlBuilder4.setPage(pagination.next + 1).getQueryString()}
            >
              {pagination.next + 1}
            </Link>
          )}
          {currentPage + 2 < pagination.pages && <span> ... </span>}
          {currentPage + 1 < pagination.pages && (
            <Link
              className="prev-button"
              to={urlBuilder5.setPage(pagination.pages).getQueryString()}
            >
              {pagination.pages}
            </Link>
          )}
          {currentPage < pagination.pages && (
            <Link
              className="next-button"
              to={urlBuilder6.setPage(pagination.next).getQueryString()}
            >
              {'Next'}
            </Link>
          )}
        </div>
      </div>
    )
  } else {
    return null
  }
}

ExtendedPagination.propTypes = {
  ...routerPropTypes,
  className: PropTypes.string,
  pagination: PropTypes.shape({
    next: PropTypes.number,
    pages: PropTypes.number,
    previous: PropTypes.number
  })
}

ExtendedPagination.displayName = 'ExtendedPagination'

export default ExtendedPagination
